import React from 'react';
import { Outlet, Link, Navigate, useLocation } from 'react-router-dom';  // Import Outlet and Link from react-router-dom
import SignageHeader from '../components/SignageHeader';
import SignageSidebar from '../components/SignageSidebar';
import DashboardFooter from '../components/DashboardFooter';
import { ToastContainer } from "react-toastify";
import { getAuthCookie, unauthenticatedLoginPath } from '../utils/authCookies';
// import "react-toastify/dist/ReactToastify.css";

interface LayoutProps {
    children?: React.ReactNode;  // Make children optional as we are using Outlet
}

const SignageLayout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  if (!getAuthCookie("sessionToken")) {
    return <Navigate to={unauthenticatedLoginPath(location.pathname, location.search)} replace />;
  }

  return (
    <div id="layout-wrapper">
      <ToastContainer />
      {/* Header component */}
      <SignageHeader />
      
      {/* Sidebar component */}
      <SignageSidebar />

      {/* Main content area */}
      <div className="main-content me-0">
        <div className="page-content">
          <div className="container-fluid">
           
            {/* Render children or Outlet (child routes) */}
            {children ? children : <Outlet />}  {/* Render children if passed, else Outlet */}
          </div>
        </div>

        {/* Footer component */}
        <DashboardFooter />
      </div>
    </div>
  );
};

export default SignageLayout;
